<footer [ngClass]="{'footer': true, 'is-size-7': true, 'has-text-centered-touch': true, 'ab-secure': isSecureForm}">
  <nav class="navbar is-white">
    <div class="container">
      <div class="navbar-brand is-block-touch">
        <!--
        <p *ngIf="!recommendedLenderActive">
          <img class="logo" src="{{ brandService.logoSrc }}" alt="{{ brandService.domain }}" *ngIf="brandService.logoSrc" [errorSrc]="brandService.logoWasabiSrc">
        </p>
        <p *ngIf="recommendedLenderActive">
          <img class="logo" src="/assets/images/recommended_logo.png" alt="Recommended Lender" *ngIf="recommendedLenderActive">
          <img class="logo" src="{{brandService.logoSrc}}" alt="{{brandService.domain}}" *ngIf="brandService.logoSrc && !recommendedLenderActive" [errorSrc]="brandService.logoWasabiSrc">
        </p>
        -->
      </div>

      <div class="phone-button" *ngIf="!brandService.isTop10">
        <p class="is-size-4" *ngIf="lenderPhoneStatus && lenderPhoneStatus.answer">
        <a class="has-text-grey-dark" href="tel:{{ lenderPhoneStatus.phone }}" target="_blank">
            Call {{ lenderPhoneStatus.phonefancy }}
          </a>
        </p>
      </div>

      <div class="navbar-end">
        <a *ngIf="!isSecureForm" class="navbar-item has-text-grey-light" href="/contact" target="_blank">
          Contact Us
        </a>
        <a class="navbar-item has-text-grey-light" href="/privacy" target="_blank">
          Privacy<span *ngIf="!isSecureForm"> Policy</span>
        </a>
        <a class="navbar-item has-text-grey-light" href="/glba" target="_blank">
          GLBA Policy
        </a>
        <a class="navbar-item has-text-grey-light" href="/cpra_policy" target="_blank">
          CPRA Policy
        </a>
        <a class="navbar-item has-text-grey-light" href="/terms" target="_blank">
          General<span *ngIf="!isSecureForm"> Terms</span>
        </a>
        <a class="navbar-item has-text-grey-light" href="/licensing_disclosure" target="_blank">
          Licensing Disclosure
        </a>
        <a *ngIf="isSecureForm" class="navbar-item has-text-grey-light" href="/your_privacy_choices" target="_blank">Privacy Preferences</a>
      </div>
    </div>
  </nav>

  <div *ngIf="brandService.isTop10 && !isSecureForm" class="container disclosure" style="margin: 10px auto;">
        <p>Top10bestlenders.com is a Marketing Lead Generator, as defined in the General Terms, and is compensated by Lenders for the services provided. Top10bestlenders.com LLC is a Licensed Mortgage Broker, as required by law, with its main office located at 440 Peoples Plaza, Newark, DE 19702. NMLS Unique Identifier #2620807. NMLS Consumer Access - <a href="https://nmlsconsumeraccess.org" target="_blank">nmlsconsumeraccess.org</a>  © Top10bestlenders.com LLC 2008 - 2024. Top10bestlenders.com Corp is Licensed Mortgage Originator as required by law. All Rights Reserved. This site is directed at, and made available to, persons in the continental U.S, and Hawaii only.</p>
        <p>LEAD GENERATOR ONLY, NOT ACTING IN THE CAPACITY OF A MORTGAGE LOAN ORIGINATOR, MORTGAGE BROKER, MORTGAGE CORRESPONDENT LENDER OR MORTGAGE LENDER. INFORMATION RECEIVED WILL BE SHARED WITH ONE OR MORE THIRD PARTIES IN CONNECTION WITH YOUR RESIDENTIAL MORTGAGE LOAN INQUIRY</p>
        <p> CT: <strong>MORTGAGE BROKER ONLY</strong>, NOT A MORTGAGE LENDER OR MORTGAGE CORRESPONDENT LENDER.</p>
          <h6>Advertising Disclosure</h6>
          <p>This site acts as a free online resource that tries to offer helpful content and comparison features to our visitors. We accept advertising compensation from companies that appear on the site. Company listings on this page DO NOT imply endorsement. We do not feature all providers on the market. Except as expressly set forth in our <a href="/terms" target="_blank">Terms of Use</a>, all representations and warranties regarding the information presented on this page are disclaimed. The information, including pricing, which appears on this site is subject to change at any time. Placement on the site could be impacted by compensation.</p>
      </div>

  <div class="container" *ngIf="!isSecureForm">
    <div class="columns">
      <div class="column copyright">
        {{ currentYear }} &copy; All Rights Reserved
      </div>

      <div *ngIf="!brandService.isTop10" class="column poweredby">
        <img class="logo" src="/images/logo-medium.png" /><br>
        Powered by FreeRateUpdate
      </div>

      <div class="column has-text-right">
        <a href="/your_privacy_choices">Privacy Preferences</a><br><br>
        <span *ngIf="!brandService.isTop10">2 Ponds Edge Drive, Chadds Ford, PA 19317</span>
      </div>

    </div>

      <p *ngIf="!brandService.isTop10" class="is-size-7 mt-6">Freerateupdate.com is a Marketing Lead Generator, as defined in the General Terms, and is compensated by Lenders for the services provided. FreeRateUpdate.com LLC is a Licensed Mortgage Broker, as required by law, with its main office located at 2 Ponds Edge Drive, Chadds Ford, PA 19317. NMLS Unique Identifier #1154338. &copy; FreeRateUpdate.com LLC 2008 - {{ currentYear }}. All Rights Reserved. This site is directed at, and made available to, persons in the continentnal U.S, and Hawaii only.</p>
  </div>
</footer>
